import { INCOME_CERTIFICATE } from 'containers/data-structure';
import { validate } from 'validate.js';
import { listOfFormsAreValidated } from 'containers/services/validateForm';

export const incomeCertificatesValidator = (incomeCertificates: any) => {
  const incomeCertificatesFields = incomeCertificates.map((incomeCertif: any) =>
    incomeCertificateValidator(incomeCertif),
  );
  return listOfFormsAreValidated(incomeCertificatesFields);
};
export const incomeCertificateValidator = (incomeCertificate: any) => {
  return validate(
    incomeCertificate,
    incomeCertificateConstraint(incomeCertificate),
  );
};

export const incomeCertificateConstraint = (incomeCertificate: any) => {
  return {
    [INCOME_CERTIFICATE.VICTIM_ID]: { presence: true },
    [INCOME_CERTIFICATE.INCOME]: { presence: true },
    [INCOME_CERTIFICATE.URL]: {
      presence: true,
    },
    [INCOME_CERTIFICATE.NAME]: {
      presence: true,
    },
    [INCOME_CERTIFICATE.TYPE]: {
      presence: true,
    },
  };
};
